<template>
  <section>
    <v-layout class="content-row">
      <span>신청금액</span>
      <span>{{ request.amount | commaFormat }} 원</span>
    </v-layout>

    <v-layout v-if="isSingleDisbursement && request?.disbursements?.length > 0" class="content-row">
      <span>계좌 정보</span>
      <span>
        {{ request.disbursements[0].bank | bankShortName }}
        {{ request.disbursements[0].accountNumber }}
        {{ request.disbursements[0].holderName }}
      </span>
    </v-layout>
    <template v-else>
      <v-layout
        class="content-row"
        v-for="(disbursement, index) in request.disbursements"
        :key="index"
      >
        <span>계좌 정보{{ request.disbursements.length > 1 ? index + 1 : '' }}</span>
        <span> {{ disbursement.bank | bankShortName }} {{ disbursement.accountNumber }} </span>
      </v-layout>
    </template>

    <v-layout v-if="isTypeCreditPay" class="content-row">
      <span>입금자명</span>
      <span>depositName</span>
    </v-layout>

    <v-layout class="content-row">
      <span>이자율</span>
      <span>연 {{ toPercentage(request.interestRate) }}%</span>
    </v-layout>

    <v-layout class="content-row">
      <span>상환 비율</span>
      <span>매출액의 {{ toPercentage(request.repaymentRatio) }}%</span>
    </v-layout>

    <v-layout class="content-row">
      <span>상환 기간 </span>
      <span>{{ request.repaymentPeriodInDays }} 일</span>
    </v-layout>

    <v-layout v-if="request.repayPrincipalFrom" class="content-row">
      <span>거치 기간</span>
      <span>{{ request.repayPrincipalFrom | moment('YYYY년 MM월 DD일') }} 까지</span>
    </v-layout>

    <v-layout class="content-row">
      <span>신청 상태</span>
      <span class="d-flex align-center justify-end">
        <RequestStatus :request="request" />
        <v-btn
          v-if="request.status === 'approve'"
          text
          small
          color="primary"
          class="ml-2"
          @click="handleDisclosure"
        >
          공시하기
        </v-btn>
      </span>
    </v-layout>
    <v-layout class="content-row">
      <span>신청일시</span>
      <span>{{ request.created | moment('YYYY년 MM월 DD일 HH:mm') }}</span>
    </v-layout>
    <v-layout v-if="request.status === 'approve' && request.approvalTime" class="content-row">
      <span>승인일시</span>
      <span>{{ request.approvalTime | moment('YYYY년 MM월 DD일 HH:mm') }}</span>
    </v-layout>
  </section>
</template>

<script>
import { toPercentage } from '@/util/mathUtil'
import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  props: ['request'],
  computed: {
    isTypeCreditPay() {
      return this.request.type === 'creditpay'
    },
    isTypeWooriCrowd() {
      return this.request.type === 'woori_crowd'
    },
    isSingleDisbursement() {
      return this.isTypeCreditPay || this.isTypeWooriCrowd
    },
  },
  methods: {
    toPercentage,
    async handleDisclosure() {
      await defaultApi.postLoansProcessRequest(this.request.uuid)
      await this.$swal.basic.alert({
        text: '공시가 완료되었습니다.',
      })
    },
  },
  components: {
    RequestStatus: () => import('@/components/loans-request/detail/RequestStatus.vue'),
  },
}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
}

.content-row {
  justify-content: space-between;

  span:nth-of-type(1) {
    padding: 4px;
    flex-basis: 30%;
  }
  span:nth-of-type(2) {
    text-align: right;
    flex-basis: 70%;
    font-weight: 700;
  }
  span {
    padding: 4px;
    flex-grow: 0;
  }
}
</style>
